import { useEffect } from "react";
import Navbar from "@/components/Navbar";
import DomainsSection from "@/components/sections/careers/DomainsSection";
import Footer from "@/components/sections/Footer";

export default function Careers() {
  useEffect(() => {
    // Set page title and meta tags
    document.title = "Career With Us | Elite Eventz Pune";
    const metaDescription = document.querySelector("meta[name='description']");
    if (metaDescription) {
      metaDescription.setAttribute(
        "content",
        "Explore career opportunities at Elite Eventz across production, execution, PR, marketing, sales, designing and technology."
      );
    } else {
      const meta = document.createElement("meta");
      meta.name = "description";
      meta.content =
        "Explore career opportunities at Elite Eventz across production, execution, PR, marketing, sales, designing and technology.";
      document.head.appendChild(meta);
    }

    // Scroll to top
    window.scrollTo(0, 0);
  }, []);

  useEffect(() => {
    const els = document.querySelectorAll(".fade-up");
    const io = new IntersectionObserver(
      (entries) => {
        entries.forEach((e) => {
          if (e.isIntersecting) {
            e.target.classList.add("in-view");
            io.unobserve(e.target);
          }
        });
      },
      { threshold: 0.12 }
    );
    els.forEach((el) => io.observe(el));
    return () => io.disconnect();
  }, []);

  return (
    <div data-testid="careers-root">
      <Navbar />
      <main>
        <DomainsSection />
      </main>
      <Footer />
    </div>
  );
}
